import { Select } from "antd";
import { useGetRolesQuery } from "api/TenantSlug/Role/hooks.ts";
import { SearchableSelectWrapperProps } from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";
import { UserSelectSearchable } from "components/UI/Selects/UserSelectSearchable/UserSelectSearchable.tsx";
import { RoleEnum } from "types/enums";

export const PartnerSelectSearchable = (props: SearchableSelectWrapperProps) => {
    const { data: rolesData, isLoading } = useGetRolesQuery({});

    const affiliateRole = rolesData?.roles.find((r) => r.name === RoleEnum.AffiliatePartner);

    // Wait for roles to load before rendering UserSelectSearchable
    // This prevents the race condition where UserSelectSearchable would load all users
    if (isLoading || !affiliateRole?.id) {
        return <Select {...props} loading disabled size={props.size ?? "middle"} />;
    }

    return <UserSelectSearchable roleId={affiliateRole.id} {...props} />;
};
